import { render, staticRenderFns } from "./ListarClassificacao.vue?vue&type=template&id=b78ab566"
import script from "./ListarClassificacao.vue?vue&type=script&lang=js"
export * from "./ListarClassificacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports